import classNames from '@/common/utils/classNames';
import haptic from '@/common/utils/haptics';
import { ForwardedRef, forwardRef, InputHTMLAttributes, useEffect, useId, useState } from 'react';

export type SwitchProps = InputHTMLAttributes<HTMLInputElement>;

export const Switch = forwardRef((props: SwitchProps, ref: ForwardedRef<any>) => {
  const { className, onChange, ...checkBoxProps } = props;
  const [isChecked, setIsChecked] = useState(checkBoxProps.defaultChecked);
  const uniqueId = useId();

  // حالت controlled: نمایش همیشه از پروپ می‌آید؛ state داخلی فقط مال uncontrolled است.
  // بدون این، کلیک state داخلی را فوری فلیپ می‌کند و اگر مقدار پروپ عوض نشود
  // (مثل فعال‌سازیِ بلاک‌شدهٔ گارد ویزیت آنلاین) سوییچِ روشنِ دروغین باقی می‌ماند.
  const isControlled = props.checked !== undefined;
  const checked = isControlled ? Boolean(props.checked) : isChecked;

  useEffect(() => {
    // فقط حالت controlled — وگرنه اجرای اولیهٔ افکت با undefined مقدار defaultChecked را می‌شوید
    if (props.checked !== undefined) setIsChecked(props.checked);
  }, [props.checked]);

  return (
    <div>
      <input
        onChange={e => {
          setIsChecked(e.target.checked);
          haptic('selection');
          onChange && onChange(e);
        }}
        type="checkbox"
        ref={ref}
        className="peer sr-only"
        {...checkBoxProps}
        id={uniqueId}
      ></input>
      <label
        htmlFor={uniqueId}
        onClick={() => setIsChecked(prev => !prev)}
        className={classNames(
          'press peer-focus-visible:outline peer-focus-visible:outline-[3px] peer-focus-visible:outline-[#96c7f2] peer-disabled:opacity-50 peer-disabled:cursor-not-allowed w-[40px] h-[25px] flex items-center justify-end bg-slate-200 rounded-full p-[4px] duration-300 ease-in-out cursor-pointer',
          {
            '!bg-primary': checked,
          },
          className,
        )}
      >
        <div
          className={classNames('bg-white w-[16px] h-[16px] rounded-full shadow-md duration-300 ease-in-out', {
            'translate-x-4': checked,
          })}
        ></div>
      </label>
    </div>
  );
});

export default Switch;
